import NewSignUp from './newsignup'
export default NewSignUp
